import { render, staticRenderFns } from "./BibliographySearchResultsDetailTable.vue?vue&type=template&id=cd14c2a8&"
import script from "./BibliographySearchResultsDetailTable.vue?vue&type=script&lang=ts&"
export * from "./BibliographySearchResultsDetailTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports